import { z } from 'zod';
export const ReferenceTargetSchema = z.object({
    kind: z.string(),
    uuid: z.string().uuid(),
});
export const TextReferenceSchema = z.object({
    field_id: z.string(),
    target: ReferenceTargetSchema.optional(),
});
export const ReferenceFieldDefinitionSchema = z.object({
    field_id: z.string(),
    label: z.string(),
    search_aliases: z.array(z.string()),
    target_kind: z.string().nullable(),
});
export const ReferenceFieldsResponseSchema = z.object({ fields: ReferenceFieldDefinitionSchema.array() });
export const ResolvedReferenceChoiceSchema = TextReferenceSchema.extend({
    label: z.string(),
    target_label: z.string().optional(),
    search_aliases: z.array(z.string()),
    display_value: z.string().nullable(),
    available: z.boolean(),
});
export const ReferenceChoicesResponseSchema = z.object({ choices: ResolvedReferenceChoiceSchema.array() });
